import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { KmsService } from '../../kms.service';
import { SwMassageBoxService } from '../../../../librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from '../../../../librarys/serves/sw-jwt.service';
import { InstanceModuleService } from '../../serves/instance/instance.module';
declare let ol, olms, $;

// 注：ol和olms版本需跟知识服务支撑平台版本对应
@Component({
    selector: 'app-kmg-map',
    templateUrl: './kmg-map.component.html',
    styleUrls: ['./kmg-map.component.css']
})
export class KmgMapComponent implements OnInit {
    // 地图对象
    mapObject = {
        map: null,
        view: null,
        vectorSource: null,
        overlay: null,
        newFeature: null,
        // 地图点击事件方法赋值
        judgeMapClick: null
    }

    // 搜索tab切换
    tabControls = ['地图服务', 'CBDB', '其它']

    // 搜索选中索引
    selectedIndex = -1;

    // 左侧搜索选中项
    selectedItem = null;

    // 搜索关键字
    addressName = '';

    // 搜索tab搜索数据
    searchMapList = [];

    // 搜索tab是否显示加载中
    isLoading = false;

    // 分页组件
    pageBase = {
        pageNum: 1,
        pageSize: 10,
        pages: 0
    }

    // 右侧tab切换选中索引
    rightTabIndex = 1;

    // 坐标录入点数据
    formModel:any = {};
    // 模板数据
    modelData:any = {};

    // 右侧历史记录集合
    rightHistoryArray = [];

    // 右侧关联位置集合
    rightRelatPositionArray = [];
    deleteIds:any = [];

    // 右侧地理位置列表选中索引值
    rightMapItemIndex = -1;

    // 右侧关联位置是否执行删除操作
    isRightMapDelete = false;

    // 地图点击的坐标
    coordinatePoint: any;

    // 气泡点击修改数据
    markerPointDatas: any;

    // 关联类型: 1 实体 2 复合属性
    category:number = 1;
    

    // 输入参数
    @Input() param: any;

    // 抛出事件
    @Output() callback = new EventEmitter();

    @ViewChild('modal') modal: SwModalframeComponent;
    constructor(
        private instanceModuleService:InstanceModuleService,
        private kmsService: KmsService,
        private message: SwMassageBoxService,
        private jwt: SwJwtService,
    ) { }

    ngOnInit() {
        this.deleteIds = [];
        // 地图初始化
        let that = this;
        setTimeout(function () {
            that.mapInit();
        }, 500);
        // 查询地理位置列表信息
        this.getMapListData();

        // 根据输入参数加载关联位置数据
        this.modelData = JSON.parse(JSON.stringify(this.param[0]));
        // 根据输入参数加载关联位置数据
        this.getAssociatedMapListData();

        // 获取历史记录数据
        if (JSON.parse(this.jwt.getlocaToken('map'))) {
            this.rightHistoryArray = JSON.parse(this.jwt.getlocaToken('map'));
        } else {
            this.rightHistoryArray = [];
        }
    }

    // 初始化地图方法
    mapInit() {
        let that = this;
        // 声明坐标系
        let aProj = ol.proj.get('EPSG:3857');
        that.mapObject.view = new ol.View({
            center: [12099282.16724, 4099021.83851],
            projection: aProj,
            zoom: 5,
            maxZoom: 20
        });
        // 初始化地图对象
        that.mapObject.map = new ol.Map({
            target: 'map',
            layers: [],
            view: that.mapObject.view
        });

        let styles = {
            'icon': new ol.style.Style({
                image: new ol.style.Icon({
                    anchor: [0.5, 1],
                    scale: 0.25,
                    src: 'assets/kgs/img/mapPoint.png'
                })
            })
        };
        // 矢量标注的数据源新添加
        that.mapObject.vectorSource = new ol.source.Vector();
        // 矢量标注图层
        let vactorLayer = new ol.layer.Vector({
            source: that.mapObject.vectorSource,
            // 设置样式
            style: function (feature) {
                return styles[feature.get('type')];
            }
        });

        // 弹框图层
        let element = document.getElementById('popup');
        that.mapObject.overlay = new ol.Overlay({
            element: element,
            positioning: 'bottom-center',
            stopEvent: true,
            offset: [0, -35]
        });

        setTimeout(() => {
            let test = olms(that.mapObject.map, 'assets/kgs/swhgis.json')
            // olms.apply(that.mapObject.map,'assets/kgs/swhgis.json');
            test.then(function () {
                that.mapObject.map.addLayer(vactorLayer);
                that.mapOnClick();
            })
        }, 500)
    }

    // 根据输入参数加载关联位置数据
    getAssociatedMapListData() {
        this.rightRelatPositionArray = [];
        for(let i=0;i<this.param.length;i++){
            if(this.param[i].attributeChName || this.param[i].attributeChNameOther){
              this.rightRelatPositionArray.push(this.param[i]);
            }
        }
    }

    // 搜索tab切换点击事件
    handleTabClick(index) {
        this.rightTabIndex = index;
        this.rightMapItemIndex = -1;
        
        // 关闭弹框
        this.colsePointBox();
    }

    // 搜索tab回车键搜索
    handelEnterSearch(event) {
        if (event.keyCode == 13) {
            this.pageBase = {
                pageNum: 1,
                pageSize: 10,
                pages: 0
            }
            // 获取地理位置坐标信息
            this.getMapListData();
        }
    }

    // 根据搜索关键字，查询相关的地理位置信息
    getMapListData() {
        this.isLoading = true;
        let params = {
            name: this.addressName,
            pageNum: this.pageBase.pageNum,
            pageSize: this.pageBase.pageSize,
            source: 0
        }
        this.kmsService.getMapPointListData(params).subscribe(
            result => {
                this.pageBase.pages = result.data.pages;
                this.isLoading = false;
                if (result.code == 200) {
                    this.searchMapList = result.data.records;
                }
            }
        )
    }

    // 地理位置检索列表点击事件
    handleMapItemClick(item, index) {
        this.selectedIndex = index;
        this.selectedItem = item;
        let point = this.pointConversion(item.geom, 0);
        this.mapObject.vectorSource.clear(true);
        this.addPointMarker([point[0], point[1]])
        this.mapTranslation(point[0], point[1], 18);
    }

    // 地理位置源数据编辑
    handleEditClick(item, event) {
        // 阻止冒泡事件
        event.stopPropagation();
        console.log(item);
    }

    // 地理位置源数据删除
    handleDeleteClick(item, event) {
        // 阻止冒泡事件
        event.stopPropagation();
        if (item.pguid) {
            this.kmsService.deleteMapPointById(item.pguid).subscribe(
                result => {
                    if (result.code == 200) {
                        this.message.success('删除成功！');
                        // 获取地理位置坐标信息
                        this.getMapListData();
                    } else{
                        this.message.info(result.msg)
                    }
                }
            )
        }
    }

    // 坐标转换方法
    pointConversion(point, type) {
        if(type === 0) {
            // 将坐标信息转为3857坐标
            let convWkt, geo;
            convWkt = new ol.format.WKT();
            geo = convWkt.readGeometry(point);
            // coordArr = geo.flatCoordinates;
            // this.newCoordPoint = ol.proj.transform(coordArr, 'EPSG:4326', 'EPSG:3857');
            // return geo.flatCoordinates;
            // console.log(ol.proj.transform(geo.flatCoordinates, 'EPSG:4326', 'EPSG:3857'));
            return ol.proj.transform(geo.flatCoordinates, 'EPSG:4326', 'EPSG:3857');
        } else {
            // let conWkt = new ol.format.WKT();
            // // let coordJwd = ol.proj.transform(point, 'EPSG:3857', 'EPSG:4326');
            // let geo = new ol.geom.Point(point);
            // this.models.geo = conWkt.writeGeometry(geo);
        }
    }

    // 地图平移方法
    mapTranslation(x, y, zoom) {
        this.mapObject.view.animate({
            center: [x, y],
            zoom: zoom,
            duration: 1000
        })
    }

    // 地图添加标记方法
    addPointMarker(point) {
        this.mapObject.newFeature = new ol.Feature({
            type: 'icon',
            geometry: new ol.geom.Point(point)
        });
        this.mapObject.newFeature.set('genre', 'costomMarker');
        this.mapObject.vectorSource.addFeature(this.mapObject.newFeature);
    }

    // 右侧检索列表分页点击事件
    handlePageClick(type) {
        switch(type) {
            // 首页
            case 'home':
                if (this.pageBase.pageNum === 1) return;
                this.pageBase.pageNum = 1;
                this.getMapListData();
            break;

            // 上一页
            case 'pre':
               if (this.pageBase.pageNum === 1) return;
               this.pageBase.pageNum = this.pageBase.pageNum - 1;
               this.getMapListData();
            break;

            // 下一页
            case 'next':
                if (this.pageBase.pageNum === this.pageBase.pages) return;
                this.pageBase.pageNum = this.pageBase.pageNum + 1;
                this.getMapListData();
            break;

            // 尾页
            case 'back':
                if (this.pageBase.pageNum === this.pageBase.pages) return;
               this.pageBase.pageNum = this.pageBase.pages;
               this.getMapListData();
            break;
        }
    }

    // 地图点击事件
    mapOnClick() {
        let that = this;
        that.mapObject.judgeMapClick = that.mapObject.map.on('click', function (evt) {
            const feature = that.mapObject.map.forEachFeatureAtPixel(evt.pixel, function (feature) {
                return feature;
            })
            if (feature) {
                if (feature.values_ && feature.values_.genre) {
                    let point = feature.values_.geometry.flatCoordinates;
                    let pointData = JSON.parse(JSON.stringify(that.modelData));
                    pointData.geo = that.selectedItem.geom;
                    pointData.attributeChName = that.selectedItem.name;
                    pointData.attributeChNameOther = that.selectedItem.address;
                    that.showMapProupData(point, pointData);
                } else if (feature.values_ && feature.values_.genreExisting) {
                    that.markerPointDatas = feature.values_;
                }
            }
        })
    }

    // 显示地图弹框信息
    showMapProupData(point, data) {
        this.formModel = data;
        this.mapObject.map.addOverlay(this.mapObject.overlay);
        this.mapObject.overlay.setPosition(point);
        $('#popup').css('display', 'block');
    }

    // 坐标点信息取消
    colsePointBox() {
        // 清除气泡信息
        this.mapObject.vectorSource.clear(true);
        $('#popup').css('display', 'none');
    }

    // 右侧关联位置修改坐标信息
    handleEditRightClick(item, index) {
        if(!item.geo){
            this.message.waring('当前字段未录入坐标信息，请删除后重新录入！');
            return;
        }
        let datas = JSON.parse(JSON.stringify(item));
        // index>=0:说明操作的是关联位置模块，需要记录索引
        if(index>=0){
            this.rightMapItemIndex = index;
        }
        // 历史记录操作模块
        else{
            datas['id'] = -1;
            datas['uuid'] = '';
            datas['triplesId'] = this.instanceModuleService.uuid2();
            datas['sourceList'] = [];
        }
        let point = this.pointConversion(item.geo, 0);

        // 清除地图标记
        this.mapObject.vectorSource.clear(true);

        // 添加地图标注信息
        this.addPointMarker([point[0], point[1]])

        // 缩放移动地图到合适位置
        this.mapTranslation(point[0], point[1], 15);

        // 显示地图弹框信息
        this.showMapProupData(point, datas);
    }

    // 右侧关联位置移除坐标信息
    handleDeleteRightClick(index,item) {
        this.isRightMapDelete = true;
        this.rightRelatPositionArray.splice(index, 1);
        this.colsePointBox();
        if(item.sourceList && item.sourceList.length>0){
            item.sourceList.forEach(element => {
                if(element.uuid){
                    this.deleteIds.push(element.uuid);
                }
            });
        }
    }


    // 将当前数据保存到浏览器缓存中
    setlocaToken() {
        // 获取浏览器缓存中的数据
        let datas = this.rightHistoryArray;
        let status = 0;
        if (datas.length > 0) {
            for(let i=0;i<datas.length;i++){
                if (datas[i].geo === this.formModel.geo) {
                    datas[i] = this.formModel;
                    status = 1;
                    break;
                }
            }
            if (status === 0) {
                datas.push(this.formModel);
            }
        } else {
            datas.push(this.formModel);
        }
        // 将当前数据保存到浏览器缓存中
        this.jwt.setlocaToken('map', JSON.stringify(datas));
        this.rightHistoryArray = JSON.parse(JSON.stringify(datas));
    }

    // 坐标点信息保存
    savePointData() {
        // 更新缓存信息
        this.setlocaToken();
        // 更新关联位置信息
        let status = 0;
        for(let i=0;i<this.rightRelatPositionArray.length;i++){
            let el = this.rightRelatPositionArray[i];
            if (el.geo === this.formModel.geo) {
                this.rightRelatPositionArray[i].attributeChName = this.formModel.attributeChName;
                this.rightRelatPositionArray[i].attributeChNameOther = this.formModel.attributeChNameOther;
                status = 1;
                break;
            }
        }
        if (status === 0) {
            let model = JSON.parse(JSON.stringify(this.modelData));
            model['id'] = -1;
            model['uuid'] = '';
            model['triplesId'] = this.instanceModuleService.uuid2();
            model['sourceList'] = [];
            model['geo'] = this.formModel.geo;
            model['attributeChName'] = this.formModel.attributeChName;
            model['attributeChNameOther'] = this.formModel.attributeChNameOther;
            this.rightRelatPositionArray.push(model);
        }
        // 关闭气泡弹框
        this.colsePointBox();
        this.message.success('数据保存成功！');
    }

    emitFunc(){
        this.callback.emit({
            'data': this.rightRelatPositionArray,
            'deleteIds': this.deleteIds
        });
    }
}
